export default function AboutSection() {
  return (
    <section className="relative w-full py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <p className="font-heading text-3xl md:text-4xl font-medium text-foreground-900 mb-10 leading-snug">
          Engineering modern digital solutions with precision, stability, and a commitment to long-term technical quality.
        </p>
        <div className="space-y-5 text-foreground-700 leading-relaxed text-base md:text-lg font-light">
          <p>
            The team at BERENGOR LIMITED builds scalable, maintainable, and high-performance systems designed for the iOS platform. Every project is approached with a strong focus on usability, stability, and long-term technical quality, ensuring that the solutions delivered remain robust and adaptable as technology evolves.
          </p>
          <p>
            Following modern software engineering practices — including clean architecture, performance optimization, and user-centered design — the team takes a disciplined approach to software development. Each component is carefully considered, each interface thoughtfully crafted, and each system architected to perform reliably under real-world conditions.
          </p>
          <p>
            The company emphasizes continuous innovation, improvement of development workflows, and adoption of up-to-date engineering standards to deliver reliable and future-ready IT solutions. Internal processes are regularly refined, and new technologies are actively explored to maintain high technical excellence across every engagement.
          </p>
        </div>
      </div>
    </section>
  );
}